<div id="step-sale-summary" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-4">

    <div class="col-12">
      @if (!saleCompletedSuccessfully) {
        <app-notice class="mb-4" type="red" [message]="'SALE_CREATE.SALE_COMPLETED_FEEDBACK_FAILURE' | translate">
        </app-notice>
      }
    </div>

    @if (!showPostSaleBlock) {
      <div class="row">
        <div class="field-wr flex flex-col col-12 mt-2">
          <div class="row">
            <div class="col-12">
              <h3 data-testid="sale-summary-title" class="border-b pb-3">{{ 'SALE_CREATE.REVIEW_AND_SUBMIT' | translate }}</h3>
            </div>

            @if (previewImageUrl) {
              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                <img data-testid="sale-summary-image" [src]="previewImageUrl"
                  [alt]="saleFormData.identifier.item?.productCustomisation?.name || saleFormData.identifier.item?.product?.name || ''"
                  class="w-100 mt-2 featured-image">
              </div>
            }

            <div class="col-12" [ngClass]="{ 'col-md-8 col-lg-9': previewImageUrl }">
              <dl class="details-grid">
                @if (saleFormData.identifier.item?.product?.brand?.name) {
                  <dt data-testid="name-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.BRAND' | translate }}</dt>
                  <dd data-testid="name" class="value pt-3 pb-3">{{ saleFormData.identifier.item?.product?.brand?.name }}</dd>
                }
                @if (saleFormData.identifier.item?.product?.name) {
                  <dt data-testid="product-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.PRODUCT' | translate }}</dt>
                  <dd data-testid="product" class="value pt-3 pb-3">{{ saleFormData.identifier.item?.product?.name | defaultValue }}</dd>
                }
                @if (saleFormData.identifier.item?.productCustomisationId) {
                  <dt data-testid="customisation-details-label"  class="label grid-cols-1 pt-3">{{ 'PRODUCT_CUSTOMIZATIONS.VIEW_PRODUCT_CUSTOMIZATIONS_DETAILS' |
                  translate }}</dt>
                  <dd data-testid="customisation-details" class="value pt-3 pb-3">{{ saleFormData.identifier.item?.productCustomisation?.name | defaultValue }}
                  </dd>
                }
                @if (saleFormData.identifier.item?.serialNumber) {
                  <dt data-testid="serialnumber-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SERIAL_NUMBER' | translate }}</dt>
                  <dd data-testid="serialnumber" class="value pt-3 pb-3">{{ saleFormData.identifier.item?.serialNumber | defaultValue }}</dd>
                }
                @if (warrantyCode) {
                  <dt data-testid="warrantycode-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.WARRANTY_CODE' | translate }}</dt>
                  <dd data-testid="warrantycode" class="value pt-3 pb-3">{{ warrantyCode | defaultValue }}</dd>
                }
                @if (saleFormData.sellerData.retailer?.text) {
                  <dt data-testid="retailer-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.RETAILER' | translate }}</dt>
                  <dd data-testid="retailer" class="value pt-3 pb-3">{{ saleFormData.sellerData.retailer?.text | defaultValue }}</dd>
                }
                @if (showDistributionChannel && saleFormData.sellerData.distributionChannel?.text) {
                  <dt data-testid="distributionchannel-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' |
                  translate }}</dt>
                  <dd data-testid="distributionchannel" class="value pt-3 pb-3">{{ saleFormData.sellerData.distributionChannel?.text |
                  defaultValue }}</dd>
                }
                @if (saleFormData.sellerData.unregisteredUser) {
                  <dt data-testid="sellername-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SELLER_NAME' | translate }}</dt>
                  <dd data-testid="sellername" class="value pt-3 pb-3">{{ saleFormData.sellerData.unregisteredUser.text | defaultValue }}</dd>
                }
                @if (saleFormData.sellerData.user) {
                  <dt data-testid="sellername-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SELLER_NAME' | translate }}</dt>
                  <dd data-testid="sellername" class="value pt-3 pb-3">{{ saleFormData.sellerData.user.text | defaultValue }}</dd>
                }
                @if (canViewPrice && saleFormData.identifier.item?.product?.price) {
                  <dt data-testid="price-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.PRICE' | translate }}</dt>
                  <dd class="value pt-3 pb-3">
                    <input data-testid="price-input" type="text" [disabled]="!canModifyPrice" [(ngModel)]="price" autocomplete="off" class="auto-width">
                    @if (saleFormData.identifier.item?.product?.price?.invalid && (saleFormData.identifier.item?.product?.price?.dirty || saleFormData.identifier.item?.product?.price?.touched)) {
                      @if (saleFormData.identifier.item?.product?.price?.errors?.['required']) {
                        <small data-testid="price-validation-error"  class="p-error">
                          {{ 'SALE_CREATE.VALIDATE_PRICE' | translate }}
                        </small>
                      }
                      @if (saleFormData.identifier.item?.product?.price?.errors?.['pattern']) {
                        <small data-testid="price-format-error"  class="p-error">
                          {{ 'SALE_CREATE.FORMAT_PRICE' | translate }}
                        </small>
                      }
                    }
                  </dd>
                }
                <dt data-testid="saledate-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.SALE_DATE' | translate }}</dt>
                <dd class="value pt-3 pb-3">
                  <div class="auto-width">
                    <p-datepicker data-testid="saledate-input"  class="xw-100 auto-width" [(ngModel)]="currentDate" dateFormat="dd-mm-yy"
                      [maxDate]="maxDate" [minDate]="minDate" [disabled]="!isCalendarEnabled" placeholder="{{ 'SALE_CREATE.DATE_PLACEHOLDER' | translate }}"
                      showIcon="true" [showTime]="true" appendTo="body" />
                  </div>
                </dd>
                <ng-container>
                  <dt data-testid="isgift-label" class="label grid-cols-1 pt-3">{{ 'SALE_CREATE.IS_GIFT' | translate }}</dt>
                  <dd class="value pt-3 pb-3">
                    <div class="col-12">
                      <label data-testid="create-sale-isgift-yes-label" class="inline-flex mr-6">
                        <p-radioButton data-testid="create-sale-isgift-yes" value="true" [(ngModel)]="isGift" inputId="yes" />
                        <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                      </label>
                      <label data-testid="create-sale-isgift-no-label" class="inline-flex mr-2">
                        <p-radioButton data-testid="create-sale-isgift-no" value="false" [(ngModel)]="isGift" inputId="no" />
                        <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                      </label>
                    </div>
                  </dd>
                </ng-container>
                @if (saleFormData.customerData != null && saleFormData.customerData.customerName) {
                  <dt data-testid="customername-label" class="label grid-cols-1 pt-3">
                    {{ 'SALE_CREATE.CUSTOMER_NAME' | translate }}
                  </dt>
                  <dd data-testid="customername" class="value pt-3 pb-3">
                    {{ saleFormData.customerData.customerName | defaultValue }}
                  </dd>
                }
              </dl>
            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="container single-view">
          <div class="field-wr flex flex-col col-12 mt-2 pt-8 border-t mb-0 pb-0">
            <div class="flex items-center justify-end gap-3">
              <button [disabled]="isSubmittingSale" data-testid="add-sale-btn" class="btn primary-btn" (click)="onCreteSale()">{{
              'SALE_CREATE.BTN_SUBMIT_SALE' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showPostSaleBlock) {
      <div class="row">
        <div class="field-wr flex flex-col items-center col-12 col-md-12">
          @if (saleCompletedSuccessfully) {
            <svg viewBox="0 0 20 20" aria-hidden="true" width="68" height="68" class="mt-5 mb-3">
              <path class="cls-1"
                d="M10,.9c5,0,9.1,4.1,9.1,9.1s-4.1,9.1-9.1,9.1S.9,15,.9,10,5,.9,10,.9M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0h0Z" />
              <path class="cls-1"
                d="M9.3,13.5c-.1,0-.2,0-.3,0l-2.6-2.1c-.2-.2-.2-.4,0-.6.2-.2.4-.2.6,0l2.3,1.8,4-5.1c.1-.2.4-.2.6,0,.2.1.2.4,0,.6l-4.3,5.5c0,0-.2.2-.3.2,0,0,0,0,0,0Z" />
            </svg>
            <p data-testid="add-sale-success"  class="mb-5">{{ 'SALE_CREATE.SALE_COMPLETED_FEEDBACK_SUCCESS' | translate }}</p>
            <div class="row mt-6 gap-4 flex items-center justify-center w-520 m-auto">
              <div class="flex flex-col col-12 col-md-6">
                <button data-testid="go-to-sale-btn" class="btn primary-btn" (click)="goToSale()">{{'SALE_CREATE.BTN_VIEW_SALE' |
                translate }}</button>
              </div>
              @if (canTakeSurvey) {
                <div class="flex flex-col col-12 col-md-6">
                  <button data-testid="go-to-survey-btn" class="btn outline-btn" (click)="goToSurvey()">{{'SALE_CREATE.BTN_TAKE_SURVEY' | translate }}</button>
                </div>
              }
              @if (!company.implicitSaleCreation && allowActivateWarranty) {
                <div class="flex flex-col col-12 col-md-6">
                  <button data-testid="warranty-activation-btn" class="btn outline-btn"
                  (click)="goToActivateWarranty()">{{'SALE_CREATE.BTN_GO_TO_WARRANTY_ACTIVATION' | translate }}</button>
                </div>
              }
            </div>
          } @else {
            <svg viewBox="0 0 20 20" aria-hidden="true" width="68" height="68" class="mt-5 mb-3">
              <path class="cls-1"
                d="M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10,10-4.5,10-10S15.5,0,10,0ZM10,19.1C5,19.1.9,15,.9,10S5,.9,10,.9s9.1,4.1,9.1,9.1-4.1,9.1-9.1,9.1Z" />
              <path class="cls-1"
                d="M13.1,6.9c-.2-.2-.5-.2-.6,0l-2.4,2.4-2.4-2.4c-.2-.2-.5-.2-.6,0-.2.2-.2.5,0,.6l2.4,2.4-2.4,2.4c-.2.2-.2.5,0,.6,0,0,.2.1.3.1s.2,0,.3-.1l2.4-2.4,2.4,2.4c0,0,.2.1.3.1s.2,0,.3-.1c.2-.2.2-.5,0-.6l-2.4-2.4,2.4-2.4c.2-.2.2-.5,0-.6h0Z" />
            </svg>
            <p data-testid="add-sale-fail">{{ 'SALE_CREATE.SALE_COMPLETED_FEEDBACK_FAILURE' | translate }}</p>
          }
        </div>
      </div>
    }
  </div>
</div>
